// Stub: expo-constants — Expo manifest/config not available on web/desktop.
// Provides a minimal API so callers (e.g. ErrorBoundary) get safe defaults.
const Constants = {
  expoConfig:           null,
  manifest:             null,
  manifest2:            null,
  appOwnership:         null,
  executionEnvironment: 'standalone',
  isDevice:             false,
  platform:             { web: {} },
  sessionId:            null,
  statusBarHeight:      0,
  systemFonts:          [],
  deviceName:           null,
};

export default Constants;
export { Constants };
